export default __webpack_public_path__ + "static/media/logo-nocircle-white.2629ed82.png";